export const FORMS_TYPES_SUCCESS = 'FORMS_TYPES_SUCCESS'
